import React, { useCallback } from 'react'
import { Drawer, Box } from '@mui/material'
import { useCampaignStatus } from '../../store/globalStore'
import CampaignSidebarContent from './CampaignSidebarContent'

const CampaignSidebar = props => {
  const {
    isBelowMdScreen,
    sidebarOpen,
    setSidebarOpen,
    campaignDetails,
    activeTab,
    onTabChange,
    tabs = []
  } = props

  const storeStatus = useCampaignStatus(campaignDetails?.id)
  const currentStatus = storeStatus || campaignDetails?.status

  const onClose = useCallback(() => {
    setSidebarOpen(false)
  }, [setSidebarOpen])

  return (
    <>
      {isBelowMdScreen
        ? (
        <Drawer
          open={sidebarOpen}
          onClose={onClose}
          className='bs-full'
          variant='persistent'
          ModalProps={{ disablePortal: true, keepMounted: true }}
          sx={{
            zIndex: sidebarOpen ? 11 : 10,
            position: 'absolute',
            height: '100%',
            '& .MuiDrawer-paper': {
              boxShadow: 'none',
              overflow: 'hidden',
              width: '260px',
              position: 'absolute',
              paddingTop: '12px'
            }
          }}
        >
          <CampaignSidebarContent
            campaignDetails={campaignDetails}
            currentStatus={currentStatus}
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
        </Drawer>
          )
        : (
        <Box sx={{
          width: '260px',
          minWidth: '260px',
          flexShrink: 0,
          borderRight: '1px solid',
          borderColor: 'divider',
          display: 'flex',
          flexDirection: 'column',
          paddingTop: '12px'
        }}>
          <CampaignSidebarContent
            campaignDetails={campaignDetails}
            currentStatus={currentStatus}
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
          />
        </Box>
          )}
    </>
  )
}

export default CampaignSidebar
